/* Extracted builder JS. Lower-page [data-nnc-tab] handler omitted. */
(() => {
  const FONTS = [
    { id: "passionate", name: "Passionate", family: "Great Vibes" },
    { id: "dreamy", name: "Dreamy", family: "Allura" },
    { id: "flowy", name: "Flowy", family: "Dancing Script" },
    { id: "original", name: "Original", family: "Monoton" },
    { id: "classic", name: "Classic", family: "Montserrat" },
    { id: "boujee", name: "Boujee", family: "Parisienne" },
    { id: "funky", name: "Funky", family: "Pacifico" },
    { id: "chic", name: "Chic", family: "Alex Brush" },
    { id: "delight", name: "Delight", family: "Cookie" },
    { id: "classy", name: "Classy", family: "Playfair Display" },
    { id: "romantic", name: "Romantic", family: "Tangerine" },
    { id: "robo", name: "Robo", family: "Orbitron" },
    { id: "charming", name: "Charming", family: "Satisfy" },
    { id: "quirky", name: "Quirky", family: "Fredoka" },
    { id: "stylish", name: "Stylish", family: "Pinyon Script" },
    { id: "sassy", name: "Sassy", family: "Lobster" },
    { id: "glam", name: "Glam", family: "Cinzel" },
    { id: "maya", name: "Maya Sans", family: "Maven Pro" },
    { id: "chemistry", name: "Chemistry", family: "Audiowide" },
    { id: "acoustic", name: "Acoustic", family: "Righteous" },
    { id: "sparky", name: "Sparky", family: "Yellowtail" },
    { id: "vibey", name: "Vibey", family: "Kalam" },
    { id: "lofi", name: "LoFi", family: "Quicksand" },
    { id: "dope", name: "Dope", family: "Bungee" },
    { id: "bossy", name: "Bossy", family: "Oswald" },
    { id: "iconic", name: "ICONIC", family: "Anton" },
    { id: "jolly", name: "Jolly", family: "Comfortaa" },
    { id: "modern", name: "MODERN", family: "Rajdhani" },
  ];

  const COLORS = [
    { name: "White", hex: "#ffffff" },
    { name: "Pink", hex: "#e5097f" },
    { name: "Green", hex: "#009846" },
    { name: "Blue", hex: "#0000ff" },
    { name: "Purple", hex: "#834e98" },
    { name: "Orange", hex: "#ef7b1b" },
    { name: "Ice Blue", hex: "#62bed3" },
    { name: "Warm White", hex: "#eedfc8" },
    { name: "Red", hex: "#e31e24" },
    { name: "Yellow", hex: "#ffed00" },
  ];

  const PREVIEW_FAIL_MESSAGE = "We could not save your preview. Please try again.";

  const moneyFormatFromLiquid = (root) => {
    const raw = root.getAttribute("data-money-format") || "{{amount}}";
    return raw.replace(/₹/g, "Rs").replace(/\bINR\b/gi, "PKR");
  };

  const groupThousands = (value, separator) =>
    String(value).replace(/\B(?=(\d{3})+(?!\d))/g, separator);

  const formatMoney = (cents, format) => {
    const amountCents = Math.round(Number(cents) || 0);
    const negative = amountCents < 0;
    const abs = negative ? -amountCents : amountCents;
    const major = Math.trunc(abs / 100);
    const minor = abs % 100;
    const minorText = String(minor).padStart(2, "0");
    const tokens = {
      amount: minor === 0 ? groupThousands(major, ",") : `${groupThousands(major, ",")}.${minorText}`,
      amount_no_decimals: groupThousands(major, ","),
      amount_with_comma_separator: `${groupThousands(major, ".")},${minorText}`,
      amount_no_decimals_with_comma_separator: groupThousands(major, "."),
      amount_with_apostrophe_separator: `${groupThousands(major, "'")}.${minorText}`,
      amount_with_space_separator: `${groupThousands(major, " ")}.${minorText}`,
      amount_no_decimals_with_space_separator: groupThousands(major, " "),
      amount_with_period_and_space_separator: `${groupThousands(major, " ")},${minorText}`,
    };
    const formatted = String(format || "{{amount}}").replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => (
      tokens[key] || tokens.amount
    ));
    return negative ? `-${formatted}` : formatted;
  };

  const escapeHtml = (value) =>
    String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");

  const sizeKey = (value) => String(value || "").trim().toLowerCase();

  const letterCount = (text) =>
    (text || "").replace(/\s+/g, "").replace(/[\r\n]/g, "").length;

  const parseJSON = (node) => {
    if (!node) return {};
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return {};
    }
  };

  const addDays = (date, days) => {
    const next = new Date(date);
    next.setDate(next.getDate() + days);
    return next;
  };

  const fmtDate = (date) =>
    date.toLocaleDateString("en-PK", { month: "short", day: "numeric" });

  const compactBackgroundUrl = (url) => {
    const raw = String(url || "").trim();
    if (!raw || raw === "featured" || raw === "room") return "";
    try {
      const parsed = new URL(raw, window.location.origin);
      if (parsed.protocol !== "http:" && parsed.protocol !== "https:") return "";
      return `${parsed.origin}${parsed.pathname}`.slice(0, 240);
    } catch (error) {
      if (/^https?:\/\//i.test(raw) || raw.startsWith("//")) return raw.slice(0, 240);
      return "";
    }
  };

  const isPublicHttpsUrl = (url) => /^https:\/\/[^\s]+$/i.test(String(url || "").trim());

  class CustomNeonBuilder extends HTMLElement {
    connectedCallback() {
      this.config = parseJSON(this.querySelector("[data-neon-config]"));
      this.product = parseJSON(this.querySelector("[data-neon-product]"));
      const variantRecords = parseJSON(this.querySelector("[data-neon-variants]"));
      this.product = {
        ...(this.product || {}),
        variants: this.mergeVariantRecords(this.product?.variants, variantRecords),
      };
      this.moneyFormat = this.config?.money_format || moneyFormatFromLiquid(this);
      this.designMode = this.getAttribute("data-design-mode") === "true" || Boolean(window.Shopify?.designMode);
      this.submitting = false;
      this.navigatingToCart = false;
      this.addSession = 0;
      this.abortController = null;
      this.progressTimer = null;
      this.progressTimeouts = [];
      this.state = {
        text: "",
        font: FONTS[0],
        color: COLORS[0],
        size: this.initialSizeRecord(),
        cutout: false,
        flash: false,
      };
      this.cacheDom();
      this.atcDefaultLabel =
        this.els.atc?.getAttribute("data-atc-label") || this.els.atc?.textContent || "ADD TO CART";
      this.renderStatic();
      this.bind();
      this.bindPageLifecycle();
      this.resetAddToCartState();
      this.update({ preview: true, commerce: true, sizes: true });
    }

    cacheDom() {
      this.els = {
        text: this.querySelector("[data-neon-text]"),
        fonts: this.querySelector("[data-neon-fonts]"),
        colors: this.querySelector("[data-neon-colors]"),
        sizes: this.querySelector("[data-neon-sizes]"),
        neon: this.querySelectorAll("[data-neon-preview]"),
        price: this.querySelectorAll("[data-neon-price]"),
        compare: this.querySelectorAll("[data-neon-compare]"),
        save: this.querySelector("[data-neon-save]"),
        offerPrice: this.querySelector("[data-neon-offer-price]"),
        error: this.querySelector("[data-neon-error]"),
        atc: this.querySelector("[data-neon-atc]"),
        adding: this.querySelector("[data-neon-adding]"),
        addingPct: this.querySelector("[data-neon-adding-pct]"),
        previewBtn: this.querySelector("[data-neon-open-preview]"),
        modal: this.querySelector("[data-neon-modal]"),
        copy: this.querySelector("[data-neon-copy]"),
        whatsapp: this.querySelector("[data-neon-whatsapp]"),
        shipToday: this.querySelector("[data-ship-today]"),
        shipReady: this.querySelector("[data-ship-ready]"),
        shipEta: this.querySelector("[data-ship-eta]"),
        cutout: this.querySelector("[data-neon-cutout]"),
        flash: this.querySelector("[data-neon-flash]"),
      };
    }

    renderStatic() {
      if (this.els.fonts) {
        this.els.fonts.innerHTML = FONTS.map(
          (font) => `
            <button type="button" class="nnc-font" data-font-id="${font.id}" style="font-family:'${font.family}',cursive">
              ${font.name}
            </button>`
        ).join("");
      }

      if (this.els.colors) {
        this.els.colors.innerHTML = COLORS.map(
          (color) => `
            <button
              type="button"
              class="nnc-color"
              data-color="${color.hex}"
              style="background:${color.hex}"
              aria-label="${color.name}"
              title="${color.name}"
            ></button>`
        ).join("");
      }

      this.renderSizes();
      this.renderDates();
    }

    variants() {
      return Array.isArray(this.product?.variants) ? this.product.variants : [];
    }

    mergeVariantRecords(productVariants, extraRecords) {
      const extras = Array.isArray(extraRecords) ? extraRecords : [];
      const extraById = new Map(extras.map((record) => [Number(record?.id), record]));
      const base = Array.isArray(productVariants) && productVariants.length ? productVariants : extras;

      return base.map((variant) => {
        const extra = extraById.get(Number(variant?.id)) || {};
        const price = variant.price ?? extra.price;
        const compareAt =
          variant.compare_at_price ??
          variant.compareAtPrice ??
          extra.compare_at_price ??
          extra.compareAtPrice ??
          null;
        return {
          ...extra,
          ...variant,
          price,
          compare_at_price: compareAt,
          compareAtPrice: compareAt,
          widthInches: extra.widthInches ?? variant.widthInches ?? null,
          heightInches: extra.heightInches ?? variant.heightInches ?? null,
        };
      });
    }

    productOptions() {
      return Array.isArray(this.product?.options) ? this.product.options : [];
    }

    optionName(option) {
      if (typeof option === "string") return option;
      return option?.name || "";
    }

    isVariantAvailable(variant) {
      return Boolean(variant) && (variant.available === true || variant.available === "true");
    }

    sizeNameOf(size) {
      if (typeof size === "string") return size;
      return size?.name || this.state?.size?.name || "";
    }

    sizeRecord(name) {
      const exact = String(name || "").trim();
      if (!exact) return null;
      return { id: sizeKey(exact), name: exact };
    }

    shopifySizeNames() {
      const sizeIndex = this.sizeOptionIndex();
      if (sizeIndex === -1) return [];

      const withValues = Array.isArray(this.product?.options_with_values)
        ? this.product.options_with_values
        : [];
      const fromOptions = withValues.find((option) => sizeKey(this.optionName(option)) === "size");
      const rawValues = Array.isArray(fromOptions?.values)
        ? fromOptions.values
        : Array.isArray(withValues[sizeIndex]?.values)
          ? withValues[sizeIndex].values
          : [];
      const names = [];
      const pushName = (value) => {
        const label = typeof value === "string" ? value : value?.name || "";
        const trimmed = String(label).trim();
        if (!trimmed) return;
        if (names.some((name) => sizeKey(name) === sizeKey(trimmed))) return;
        names.push(trimmed);
      };
      rawValues.forEach(pushName);
      if (!names.length) {
        this.variants().forEach((variant) => {
          const fromOption = variant[`option${sizeIndex + 1}`];
          if (fromOption) pushName(fromOption);
          else if (Array.isArray(variant.options)) pushName(variant.options[sizeIndex]);
        });
      }
      return names;
    }

    parseInches(value) {
      if (value == null || value === "") return null;
      const parsed = Number(value);
      if (!Number.isFinite(parsed) || parsed <= 0) return null;
      return parsed;
    }

    formatInches(value) {
      const parsed = this.parseInches(value);
      if (parsed == null) return null;
      const scaled = Math.round(parsed * 100);
      if (scaled % 100 === 0) return String(Math.trunc(scaled / 100));
      if (scaled % 10 === 0) return `${Math.trunc(scaled / 100)}.${Math.trunc((scaled % 100) / 10)}`;
      return `${Math.trunc(scaled / 100)}.${String(scaled % 100).padStart(2, "0")}`;
    }

    variantCompareAt(variant) {
      const raw = variant?.compare_at_price ?? variant?.compareAtPrice;
      if (raw == null || raw === "") return 0;
      return Number(raw) || 0;
    }

    renderMoney(node, cents) {
      if (!node) return;
      node.textContent = formatMoney(cents, this.moneyFormat);
    }

    updatePrice(variant, payableCents) {
      if (!variant) return;

      const price = Number(variant.price || 0);
      const compareAtPrice = this.variantCompareAt(variant);
      const payable = Number.isFinite(Number(payableCents)) ? Number(payableCents) : price;

      this.els.price.forEach((node) => {
        const kind = node.getAttribute("data-neon-price-kind");
        this.renderMoney(node, kind === "variant" ? price : payable);
        node.classList.toggle("is-empty", (kind === "variant" ? price : payable) === 0);
      });

      this.els.compare.forEach((node) => {
        if (compareAtPrice > price) {
          this.renderMoney(node, compareAtPrice);
          node.hidden = false;
          node.classList.remove("hidden");
          node.removeAttribute("hidden");
        } else {
          node.hidden = true;
          node.classList.add("hidden");
          node.setAttribute("hidden", "");
          node.textContent = "";
        }
      });
    }

    variantWidth(variant) {
      return this.parseInches(variant?.widthInches ?? variant?.width_inches);
    }

    variantHeight(variant) {
      return this.parseInches(variant?.heightInches ?? variant?.height_inches);
    }

    isDesignMode() {
      return this.designMode || this.getAttribute("data-design-mode") === "true" || Boolean(window.Shopify?.designMode);
    }

    sizeOptionIndex() {
      const fromDom = this.getAttribute("data-size-option-index");
      if (fromDom !== null && fromDom !== "" && Number.isInteger(Number(fromDom))) {
        return Number(fromDom);
      }

      const isSize = (option) => String(this.optionName(option) || "").trim().toLowerCase() === "size";

      const options = this.productOptions();
      const sizeIndex = options.findIndex(isSize);
      if (sizeIndex !== -1) return sizeIndex;

      const withValues = Array.isArray(this.product?.options_with_values)
        ? this.product.options_with_values
        : [];
      return withValues.findIndex(isSize);
    }

    findSizeVariant(sizeName) {
      const variants = this.variants();
      const sizeIndex = this.sizeOptionIndex();
      if (sizeIndex === -1) return null;

      const optionKey = `option${sizeIndex + 1}`;
      const target = String(this.sizeNameOf(sizeName) || "").trim().toLowerCase();
      if (!target) return null;

      return (
        variants.find((variant) => {
          const fromOption = String(variant[optionKey] || "").trim().toLowerCase();
          if (fromOption === target) return true;
          if (Array.isArray(variant.options)) {
            return String(variant.options[sizeIndex] || "").trim().toLowerCase() === target;
          }
          return false;
        }) || null
      );
    }

    firstAvailableSize() {
      return this.shopifySizeNames()
        .map((name) => this.sizeRecord(name))
        .find((size) => this.isVariantAvailable(this.findSizeVariant(size.name))) || null;
    }

    initialSizeRecord() {
      const fromDom = this.sizeRecord(this.getAttribute("data-initial-size"));
      if (fromDom && this.findSizeVariant(fromDom.name)) return fromDom;

      const selected = this.product?.selected_or_first_available_variant || this.product?.selectedOrFirstAvailableVariant;
      if (selected) {
        const sizeIndex = this.sizeOptionIndex();
        const fromSelected =
          (sizeIndex >= 0 && (selected[`option${sizeIndex + 1}`] || selected.options?.[sizeIndex])) ||
          selected.title;
        const record = this.sizeRecord(fromSelected);
        if (record && this.findSizeVariant(record.name)) return record;
      }

      return this.firstAvailableSize() || this.sizeRecord(this.shopifySizeNames()[0]);
    }

    selectedVariant() {
      const variant = this.findSizeVariant(this.state.size?.name);
      if (!this.isVariantAvailable(variant)) return null;
      return variant;
    }

    syncHiddenVariantInput(variant) {
      const input = this.querySelector("[data-neon-variant-id]");
      if (!input) return;
      if (variant?.id) input.value = String(variant.id);
    }

    addonData(key) {
      const addon = this.config?.addons?.[key];
      if (!addon || !addon.id) return null;
      return addon;
    }

    selectedAddonNames() {
      const names = [];
      if (this.state.cutout && this.addonData("smart_cutout")) {
        names.push(this.addonData("smart_cutout").label || "Smart Cutout");
      }
      if (this.state.flash && this.addonData("flash_controller")) {
        names.push(this.addonData("flash_controller").label || "Flash Controller");
      }
      return names.join(", ") || "None";
    }

    renderSizes() {
      if (!this.els.sizes) return;
      const names = this.shopifySizeNames();
      const sizeIndex = this.sizeOptionIndex();
      if (sizeIndex === -1 || !names.length) {
        this.els.sizes.innerHTML = `<p class="nnc-size-config-error">Size configuration error: this product needs a Shopify option named Size.</p>`;
        return;
      }

      let missingDimensions = false;
      this.els.sizes.innerHTML = names.map((name) => {
        const size = this.sizeRecord(name);
        const variant = this.findSizeVariant(name);
        const available = this.isVariantAvailable(variant);
        const active = sizeKey(this.state.size?.name) === sizeKey(name) ? "is-active" : "";
        const widthLabel = this.formatInches(this.variantWidth(variant));
        const heightLabel = this.formatInches(this.variantHeight(variant));
        if (variant && (widthLabel == null || heightLabel == null)) missingDimensions = true;

        let title = escapeHtml(name);
        let priceLabel = "";
        let compareMarkup = "";
        let status = "available";
        if (!variant) {
          title = `${escapeHtml(name)} · Size configuration error`;
          priceLabel = "Size configuration error";
          status = "unmapped";
        } else if (!available) {
          title = `${escapeHtml(name)} · Sold out`;
          priceLabel = `${formatMoney(Number(variant.price), this.moneyFormat)} · Unavailable`;
          status = "unavailable";
        } else {
          priceLabel = formatMoney(Number(variant.price), this.moneyFormat);
          const compareAt = this.variantCompareAt(variant);
          if (compareAt > Number(variant.price)) {
            compareMarkup = `<span class="nnc-size-compare">${escapeHtml(formatMoney(compareAt, this.moneyFormat))}</span>`;
          }
        }

        const widthText = widthLabel == null ? "Width: —" : `Width: ${widthLabel}″`;
        const heightText = heightLabel == null ? "Height: —" : `Height: ${heightLabel}″`;
        const missingClass = variant && (widthLabel == null || heightLabel == null) ? " nnc-size-missing" : "";

        return `
          <button type="button" class="nnc-size ${active}" data-size-id="${escapeHtml(size.id)}" data-size-name="${escapeHtml(name)}" data-size-status="${status}" ${available ? "" : "disabled"}>
            <strong>${title}</strong>
            <span class="${missingClass.trim()}">${widthText}</span>
            <span class="${missingClass.trim()}">${heightText}</span>
            <span class="nnc-size-price">${priceLabel}</span>
            ${compareMarkup}
          </button>`;
      }).join("");

      if (this.isDesignMode() && missingDimensions) {
        const note = document.createElement("p");
        note.className = "nnc-size-config-error";
        note.textContent = "Set variant metafields custom.width_inches and custom.height_inches in Shopify Admin. Add to Cart still uses the real Shopify variant.";
        this.els.sizes.appendChild(note);
      }
    }

    renderDates() {
      const now = new Date();
      if (this.els.shipToday) this.els.shipToday.textContent = fmtDate(now);
      if (this.els.shipReady) {
        this.els.shipReady.textContent = `${fmtDate(addDays(now, 2))} - ${fmtDate(addDays(now, 4))}`;
      }
      if (this.els.shipEta) {
        this.els.shipEta.textContent = `${fmtDate(addDays(now, 10))} - ${fmtDate(addDays(now, 12))}`;
      }
    }

    bind() {
      this.els.text?.addEventListener("input", () => {
        this.state.text = this.els.text.value;
        this.update({ preview: true, commerce: false, sizes: false });
      });

      this.els.fonts?.addEventListener("click", (event) => {
        const button = event.target.closest("[data-font-id]");
        if (!button) return;
        this.state.font = FONTS.find((font) => font.id === button.dataset.fontId) || FONTS[0];
        this.update({ preview: true, commerce: false, sizes: false });
      });

      this.els.colors?.addEventListener("click", (event) => {
        const button = event.target.closest("[data-color]");
        if (!button) return;
        this.state.color = COLORS.find((color) => color.hex === button.dataset.color) || COLORS[0];
        this.update({ preview: true, commerce: false, sizes: false });
      });

      this.els.sizes?.addEventListener("click", (event) => {
        const button = event.target.closest("[data-size-id]");
        if (!button || button.disabled) return;
        const next = this.sizeRecord(button.dataset.sizeName || button.dataset.sizeId);
        if (!next) {
          this.showError("Size configuration error");
          return;
        }
        const variant = this.findSizeVariant(next.name);
        if (!variant) {
          this.showError("Size configuration error");
          return;
        }
        if (!this.isVariantAvailable(variant)) {
          this.showError("This size is currently unavailable.");
          return;
        }
        this.state.size = next;
        this.syncHiddenVariantInput(variant);
        this.update({ preview: false, commerce: true, sizes: true });
      });

      this.els.cutout?.addEventListener("change", () => {
        this.state.cutout = Boolean(this.els.cutout.checked);
        this.update({ preview: false, commerce: true, sizes: false });
      });

      this.els.flash?.addEventListener("change", () => {
        this.state.flash = Boolean(this.els.flash.checked);
        this.update({ preview: false, commerce: true, sizes: false });
      });

      this.els.previewBtn?.addEventListener("click", () => this.toggleModal(true));
      this.els.modal?.addEventListener("click", (event) => {
        if (event.target.matches("[data-neon-modal], [data-neon-close]")) this.toggleModal(false);
      });

      this.els.copy?.addEventListener("click", async () => {
        const code = this.config.discount_code || "NEON20";
        try {
          await navigator.clipboard.writeText(code);
          this.els.copy.textContent = "Copied";
          setTimeout(() => {
            this.els.copy.textContent = "Copy";
          }, 1600);
        } catch (error) {
          this.els.copy.textContent = code;
        }
      });

      this.els.atc?.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.addToCart();
      });
    }

    calc() {
      const letters = letterCount(this.state.text);
      const variant = this.findSizeVariant(this.state.size?.name);
      const sizeCents = variant && Number.isFinite(Number(variant.price)) ? Number(variant.price) : 0;
      const compareAt = this.variantCompareAt(variant);
      const cutout = this.addonData("smart_cutout");
      const flash = this.addonData("flash_controller");
      const smartCutoutSelected = Boolean(this.state.cutout && cutout?.id);
      const flashControllerSelected = Boolean(this.state.flash && flash?.id);
      const addonCents =
        (smartCutoutSelected ? Number(cutout.price) || 0 : 0) +
        (flashControllerSelected ? Number(flash.price) || 0 : 0);
      const totalCents = sizeCents + addonCents;
      return {
        letters,
        sizeCents,
        compareAt,
        cents: totalCents,
        variant,
        smartCutoutSelected,
        flashControllerSelected,
        width: this.variantWidth(variant),
        height: this.variantHeight(variant),
      };
    }

    chargePlan(calc, extras = {}) {
      const sizeVariant = this.selectedVariant();
      if (!sizeVariant) {
        return {
          items: [],
          error: "This size is currently unavailable.",
        };
      }

      const cutout = this.addonData("smart_cutout");
      const flash = this.addonData("flash_controller");

      if (this.state.cutout) {
        if (!cutout?.id) {
          return { items: [], error: "Smart Cutout is not configured." };
        }
        if (cutout.available !== true) {
          return { items: [], error: "Smart Cutout is currently unavailable." };
        }
      }

      if (this.state.flash) {
        if (!flash?.id) {
          return { items: [], error: "Flash Controller is not configured." };
        }
        if (flash.available !== true) {
          return { items: [], error: "Flash Controller is currently unavailable." };
        }
      }

      const previewUrl = extras.previewUrl || "";
      const bundleId = extras.bundleId || "";
      const selectedText = this.state.text.trim();
      const items = [
        {
          id: sizeVariant.id,
          quantity: 1,
          properties: {
            "Custom Text": selectedText,
            Font: this.state.font.name,
            "Neon Colour": this.state.color.name,
            Size: sizeVariant[`option${this.sizeOptionIndex() + 1}`] ||
              sizeVariant.options?.[this.sizeOptionIndex()] ||
              this.state.size?.name ||
              "",
            "Selected Add-ons": this.selectedAddonNames(),
            "Preview Image": previewUrl,
            "_Neoniify Bundle ID": bundleId,
            "_Preview Background": this.roomBackgroundUrl(),
            "_Preview Version": "1",
          },
        },
      ];

      if (calc.smartCutoutSelected) {
        items.push({
          id: Number(cutout.id),
          quantity: 1,
          properties: {
            "For Custom Sign": selectedText,
            "_Neoniify Bundle ID": bundleId,
            "_Neoniify Parent": "true",
          },
        });
      }

      if (calc.flashControllerSelected) {
        items.push({
          id: Number(flash.id),
          quantity: 1,
          properties: {
            "For Custom Sign": selectedText,
            "_Neoniify Bundle ID": bundleId,
            "_Neoniify Parent": "true",
          },
        });
      }

      return { items, error: "" };
    }

    update(parts = { preview: true, commerce: true, sizes: true }) {
      const calc = this.calc();
      const display = this.state.text.trim() || "Text Preview";

      if (parts.preview !== false) {
        this.style.setProperty("--neon-color", this.state.color.hex);
        this.style.setProperty("--neon-font", `'${this.state.font.family}', cursive`);
        this.els.neon.forEach((node) => {
          node.textContent = display;
        });
        this.querySelectorAll("[data-font-id]").forEach((button) => {
          button.classList.toggle("is-active", button.dataset.fontId === this.state.font.id);
        });
        this.querySelectorAll("[data-color]").forEach((button) => {
          button.classList.toggle("is-active", button.dataset.color === this.state.color.hex);
        });
      }

      if (parts.commerce !== false) {
        this.updatePrice(calc.variant, calc.cents);

        if (this.els.save) {
          const showSave = calc.compareAt > calc.sizeCents && calc.sizeCents > 0;
          if (showSave) {
            const percent = Math.trunc(((calc.compareAt - calc.sizeCents) * 100) / calc.compareAt);
            this.els.save.hidden = percent < 1;
            this.els.save.textContent = percent >= 1 ? `-${percent}%` : "";
          } else {
            this.els.save.hidden = true;
            this.els.save.textContent = "";
          }
        }

        if (this.els.offerPrice) {
          const discount = Number(this.config.discount_percent || 0);
          const offer = calc.cents - Math.trunc((calc.cents * discount) / 100);
          this.els.offerPrice.textContent = formatMoney(offer, this.moneyFormat);
        }

        this.syncHiddenVariantInput(calc.variant);
      }

      if (parts.sizes !== false) this.renderSizes();
      this.updateWhatsapp(calc);

      const mappedVariant = calc.variant;
      const variantReady = this.isVariantAvailable(mappedVariant);
      if (this.els.atc) {
        this.els.atc.disabled = this.submitting || calc.letters === 0 || !variantReady;
      }
      if (this.sizeOptionIndex() === -1 || !this.state.size) {
        this.showError("Size configuration error");
      } else if (!mappedVariant) {
        this.showError("Size configuration error");
      } else if (!variantReady) {
        this.showError("This size is currently unavailable.");
      } else if (
        this.els.error?.textContent === "This size is currently unavailable." ||
        this.els.error?.textContent === "Size configuration error"
      ) {
        this.showError("");
      }
    }

    updateWhatsapp(calc) {
      if (!this.els.whatsapp) return;
      const number = (this.config.whatsapp || "").replace(/\D/g, "");
      const widthLabel = this.formatInches(calc.width);
      const heightLabel = this.formatInches(calc.height);
      const dimensionText =
        widthLabel != null && heightLabel != null ? ` (${widthLabel}" x ${heightLabel}")` : "";
      const msg = encodeURIComponent(
        `Hi, I want a custom neon sign.\nText: ${this.state.text || "-"}\nFont: ${this.state.font.name}\nColour: ${this.state.color.name}\nSize: ${this.state.size?.name || "-"}${dimensionText}\nAdd-ons: ${this.selectedAddonNames()}\nQuoted price: ${formatMoney(calc.cents, this.moneyFormat)}`
      );
      this.els.whatsapp.href = number ? `https://wa.me/${number}?text=${msg}` : `https://wa.me/?text=${msg}`;
    }

    toggleModal(open) {
      this.els.modal?.classList.toggle("is-open", open);
    }

    roomBackgroundUrl() {
      const stage = this.querySelector(".nnc-preview-col img.nnc-stage-bg") || this.querySelector("img.nnc-stage-bg");
      return compactBackgroundUrl(
        this.config.room_image || this.getAttribute("data-room-image") || stage?.currentSrc || stage?.src || ""
      );
    }

    bindPageLifecycle() {
      if (window.__neoniifyAtcResetBound) return;
      window.__neoniifyAtcResetBound = true;

      window.addEventListener("pageshow", (event) => {
        // Reset stale submitting/loading UI, including BFCache restoration
        // when event.persisted === true, and cached DOM without a full reload.
        document.querySelectorAll("custom-neon-builder").forEach((node) => {
          if (typeof node.resetAddToCartState === "function") node.resetAddToCartState();
        });
      });
    }

    clearProgressTimers() {
      if (this.progressTimer) {
        window.clearInterval(this.progressTimer);
        this.progressTimer = null;
      }
      (this.progressTimeouts || []).forEach((id) => window.clearTimeout(id));
      this.progressTimeouts = [];
    }

    lockPageForAdd(lock) {
      const root = document.documentElement;
      const body = document.body;
      if (lock) {
        root?.classList.add("nnc-atc-lock");
        body?.classList.add("nnc-atc-lock");
      } else {
        root?.classList.remove("nnc-atc-lock");
        body?.classList.remove("nnc-atc-lock");
        if (root) root.style.overflow = "";
        if (body) body.style.overflow = "";
      }
    }

    resetAddToCartState() {
      try {
        this.addSession = (this.addSession || 0) + 1;
        this.submitting = false;
        this.navigatingToCart = false;
        this.clearProgressTimers();

        if (this.abortController) {
          try {
            this.abortController.abort();
          } catch (error) {
            /* already aborted */
          }
          this.abortController = null;
        }

        this.showAdding(false, 0);

        if (this.els?.adding) {
          this.els.adding.hidden = true;
          this.els.adding.setAttribute("hidden", "");
          this.els.adding.classList.remove("is-visible", "is-active", "is-open");
          this.els.adding.setAttribute("aria-hidden", "true");
        }

        if (this.els?.atc) {
          const calc = this.calc();
          this.els.atc.classList.remove("is-loading");
          this.els.atc.removeAttribute("aria-busy");
          this.els.atc.removeAttribute("aria-disabled");
          this.els.atc.textContent =
            this.atcDefaultLabel || this.els.atc.getAttribute("data-atc-label") || "ADD TO CART";
          this.els.atc.disabled = calc.letters === 0 || !this.selectedVariant();
        }

        this.lockPageForAdd(false);
      } catch (error) {
        this.submitting = false;
        this.navigatingToCart = false;
        this.lockPageForAdd(false);
      }
    }

    setSubmitting(active) {
      this.submitting = Boolean(active);
      if (this.els.atc) {
        this.els.atc.classList.toggle("is-loading", this.submitting);
        this.els.atc.toggleAttribute("aria-busy", this.submitting);
        const calc = this.calc();
        this.els.atc.disabled = this.submitting || calc.letters === 0 || !this.selectedVariant();
        if (this.submitting) this.els.atc.setAttribute("aria-disabled", "true");
        else this.els.atc.removeAttribute("aria-disabled");
      }
    }

    async addToCart() {
      if (this.submitting || this.navigatingToCart) return;

      const calc = this.calc();
      if (!calc.letters) {
        this.showError("Type your text to continue.");
        this.els.text?.focus();
        return;
      }

      const availability = this.chargePlan(calc, { previewUrl: "pending", bundleId: "pending" });
      if (availability.error || !availability.items.length) {
        this.showError(availability.error || "This size is currently unavailable.");
        return;
      }

      this.abortController?.abort();
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      const session = (this.addSession || 0) + 1;
      this.addSession = session;

      this.setSubmitting(true);
      this.showError("");
      this.showAdding(true, 8);

      try {
        this.showAdding(true, 22);
        let previewBlob;
        try {
          previewBlob = await this.capturePreviewBlob();
        } catch (captureError) {
          const error = new Error(PREVIEW_FAIL_MESSAGE);
          error.cause = captureError;
          throw error;
        }
        if (signal.aborted || session !== this.addSession) return;
        if (!previewBlob) {
          throw new Error(PREVIEW_FAIL_MESSAGE);
        }

        this.showAdding(true, 48);
        const uploadedPreviewUrl = await this.uploadPreview(previewBlob, signal);
        if (signal.aborted || session !== this.addSession) return;
        if (!isPublicHttpsUrl(uploadedPreviewUrl)) {
          throw new Error(PREVIEW_FAIL_MESSAGE);
        }

        const bundleId =
          window.crypto?.randomUUID?.() ||
          `neoniify-${Date.now()}-${Math.random().toString(36).slice(2)}`;

        const plan = this.chargePlan(calc, {
          previewUrl: uploadedPreviewUrl,
          bundleId,
        });
        if (plan.error || !plan.items.length) {
          throw new Error(plan.error || "Could not add this sign to cart.");
        }
        if (!plan.items[0].properties["Preview Image"]) {
          throw new Error(PREVIEW_FAIL_MESSAGE);
        }

        this.showAdding(true, 78);
        const root = window.Shopify?.routes?.root || "/";
        const cartAdd = window.routes?.cart_add_url || `${root}cart/add.js`;
        const response = await fetch(cartAdd, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ items: plan.items }),
          signal,
        });
        if (signal.aborted || session !== this.addSession) return;
        const data = await response.json().catch(() => ({}));
        if (signal.aborted || session !== this.addSession) return;
        if (!response.ok || data.status || data.message === "Cart Error" || data.description) {
          throw new Error(data.description || data.message || "Could not add this sign to cart.");
        }

        if (signal.aborted || session !== this.addSession) return;
        this.showAdding(true, 100);
        this.updateCartCount();

        const drawer = document.querySelector("cart-drawer");
        try {
          if (drawer && typeof drawer.refreshFromShopify === "function") {
            await drawer.refreshFromShopify({ open: true });
            if (signal.aborted || session !== this.addSession) return;
            this.resetAddToCartState();
            return;
          }
        } catch (drawerError) {
          console.error("Neoniify cart drawer open failed:", drawerError);
        }

        this.navigatingToCart = true;
        window.location = window.routes?.cart_url || `${root}cart`;
      } catch (error) {
        if (error?.name === "AbortError" || this.abortController?.signal?.aborted) {
          return;
        }
        this.resetAddToCartState();
        if (error && error.message === PREVIEW_FAIL_MESSAGE) {
          console.error("Neoniify preview upload failed:", error.cause || error);
          this.showError(PREVIEW_FAIL_MESSAGE);
        } else {
          console.error("Neoniify add to cart failed:", error);
          this.showError(error.message || "Could not add this sign to cart.");
        }
      } finally {
        if (!this.navigatingToCart) {
          this.setSubmitting(false);
        }
      }
    }

    showAdding(open, percent) {
      if (!this.els.adding) return;
      this.els.adding.hidden = !open;
      if (open) {
        this.els.adding.removeAttribute("hidden");
        this.els.adding.classList.add("is-visible");
        this.els.adding.setAttribute("aria-hidden", "false");
        this.lockPageForAdd(true);
      } else {
        this.els.adding.setAttribute("hidden", "");
        this.els.adding.classList.remove("is-visible", "is-active", "is-open");
        this.els.adding.setAttribute("aria-hidden", "true");
        this.lockPageForAdd(false);
      }
      if (typeof percent === "number" && this.els.addingPct) {
        this.els.addingPct.textContent = `${Math.max(0, Math.min(100, Math.round(percent)))}%`;
      }
    }

    async waitForPreviewAssets() {
      const img =
        this.querySelector(".nnc-preview-col img.nnc-stage-bg") || this.querySelector("img.nnc-stage-bg");
      if (img && !img.complete) {
        await new Promise((resolve) => {
          img.addEventListener("load", resolve, { once: true });
          img.addEventListener("error", resolve, { once: true });
        });
      }
      try {
        if (document.fonts?.load) {
          await document.fonts.load(`72px "${this.state.font.family}"`);
        }
        if (document.fonts?.ready) await document.fonts.ready;
      } catch (error) {
        /* fallback font */
      }
    }

    drawCover(ctx, image, size) {
      if (!image || !image.width || !image.height) return false;
      const scale = Math.max(size / image.width, size / image.height);
      const width = image.width * scale;
      const height = image.height * scale;
      ctx.drawImage(image, (size - width) / 2, (size - height) / 2, width, height);
      return true;
    }

    async paintPreview(ctx, size) {
      this.drawRoom(ctx, size);
      const bg = this.querySelector(".nnc-preview-col img.nnc-stage-bg") || this.querySelector("img.nnc-stage-bg");
      const src = bg?.currentSrc || bg?.src;
      if (src) {
        try {
          const response = await fetch(src, { mode: "cors", credentials: "omit" });
          if (response.ok) {
            const blob = await response.blob();
            const image = await createImageBitmap(blob);
            this.drawCover(ctx, image, size);
          }
        } catch (error) {
          this.drawRoom(ctx, size);
        }
      }

      const text = this.state.text.trim() || "Text Preview";
      const fontSize = Math.max(28, Math.min(72, Math.floor(size / Math.max(text.length * 0.55, 8))));
      try {
        await document.fonts.load(`${fontSize}px "${this.state.font.family}"`);
      } catch (error) {
        /* fallback font */
      }

      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.font = `${fontSize}px "${this.state.font.family}", cursive`;
      ctx.fillStyle = this.state.color.hex;
      ctx.shadowColor = this.state.color.hex;
      ctx.shadowBlur = 42;
      ctx.fillText(text, size / 2, size * 0.29);
      ctx.shadowBlur = 18;
      ctx.fillText(text, size / 2, size * 0.29);
    }

    canvasToBlob(canvas) {
      return new Promise((resolve) => {
        canvas.toBlob((blob) => resolve(blob), "image/webp", 0.92);
      }).then((blob) => {
        if (blob && blob.size > 0) return blob;
        return new Promise((resolve) => {
          canvas.toBlob((png) => resolve(png), "image/png", 0.92);
        });
      });
    }

    async capturePreviewBlob() {
      this.toggleModal(false);
      this.showAdding(true, 18);
      await this.waitForPreviewAssets();
      const size = 1000;
      const canvas = document.createElement("canvas");
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext("2d");
      if (!ctx) return null;
      await this.paintPreview(ctx, size);
      return this.canvasToBlob(canvas);
    }

    previewFilename(blob) {
      const selectedText = this.state.text.trim();
      const safeText = selectedText
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-|-$/g, "")
        .slice(0, 30);
      const uuid = window.crypto?.randomUUID?.() || Math.random().toString(36).slice(2);
      const ext = blob?.type === "image/png" ? "png" : "webp";
      return `${Date.now()}-${uuid}-${safeText || "custom-neon"}.${ext}`;
    }

    async uploadPreview(blob, signal) {
      const supabase = this.config.supabase || {};
      const url = String(supabase.url || "").replace(/\/$/, "").trim();
      const anonKey = String(supabase.anonKey || "").trim();
      const bucket = String(supabase.bucket || "").trim();

      if (!url || !anonKey || !bucket) {
        const error = new Error(PREVIEW_FAIL_MESSAGE);
        error.cause = new Error("Supabase URL, anonymous key, or bucket is missing from theme settings.");
        throw error;
      }

      const now = new Date();
      const year = now.getUTCFullYear();
      const month = String(now.getUTCMonth() + 1).padStart(2, "0");
      const filename = this.previewFilename(blob);
      const path = `${year}/${month}/${filename}`;
      const endpoint = `${url}/storage/v1/object/${encodeURIComponent(bucket)}/${path}`;

      let response;
      try {
        response = await fetch(endpoint, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${anonKey}`,
            apikey: anonKey,
            "Content-Type": blob.type || "image/webp",
            "x-upsert": "false",
          },
          body: blob,
          signal,
        });
      } catch (networkError) {
        if (networkError?.name === "AbortError") throw networkError;
        const error = new Error(PREVIEW_FAIL_MESSAGE);
        error.cause = networkError;
        throw error;
      }

      if (!response.ok) {
        const detail = await response.text().catch(() => response.statusText);
        const error = new Error(PREVIEW_FAIL_MESSAGE);
        error.cause = new Error(`Supabase upload ${response.status}: ${detail}`);
        throw error;
      }

      const publicUrl = `${url}/storage/v1/object/public/${bucket}/${path}`;
      if (!isPublicHttpsUrl(publicUrl)) {
        const error = new Error(PREVIEW_FAIL_MESSAGE);
        error.cause = new Error(`Invalid public URL: ${publicUrl}`);
        throw error;
      }
      return publicUrl;
    }

    drawRoom(ctx, size) {
      ctx.fillStyle = "#1a1a1a";
      ctx.fillRect(0, 0, size, size);
      ctx.fillStyle = "#232323";
      ctx.fillRect(0, 0, size, size * 0.65);
      ctx.fillStyle = "#3a3a3a";
      ctx.fillRect(0, size * 0.647, size, 8);
      ctx.fillStyle = "#d4a017";
      ctx.beginPath();
      ctx.moveTo(size * 0.11, size * 0.8);
      ctx.lineTo(size * 0.2, size * 0.59);
      ctx.lineTo(size * 0.8, size * 0.59);
      ctx.lineTo(size * 0.89, size * 0.8);
      ctx.closePath();
      ctx.fill();
      ctx.fillStyle = "#121212";
      ctx.fillRect(0, size * 0.885, size, size * 0.115);
    }

    async updateCartCount() {
      try {
        const cartUrl = window.routes?.cart_url || "/cart";
        const cartJs = cartUrl.endsWith(".js") ? cartUrl : `${cartUrl}.js`;
        const cart = await fetch(cartJs).then((response) => response.json());
        document.querySelectorAll(".nh-cart-count").forEach((node) => {
          node.textContent = cart.item_count;
          node.hidden = cart.item_count < 1;
        });
      } catch (error) {
        /* header count can stay stale if cart.js is unavailable */
      }
    }

    showError(message) {
      if (this.els.error) this.els.error.textContent = message || "";
    }
  }

  if (!customElements.get("custom-neon-builder")) {
    customElements.define("custom-neon-builder", CustomNeonBuilder);
  }
})();
